$(function(){
  var path = location.pathname.substr(1);
  if (path === 'corporate') {
    location.href = 'https://vivivit.co.jp/about';
  }
});
